import PropTypes from "prop-types";

const FormSection = ({ title, description, children }) => {
  return (
    <div className="flex flex-col md:flex-row gap-8 items-start">
      <div className="w-full md:w-1/3">
        <h3 className="text-lg font-semibold text-gray-900 pt-0 m-0">{title}</h3>

        <p className="text-gray-500 text-md pt-0 mt-0">{description}</p>
      </div>

      <div className="w-full md:w-2/3">{children}</div>
    </div>
  );
};
FormSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
  noDivider: PropTypes.bool,
};

export default FormSection;

